module.exports = __webpack_public_path__ + "static/media/spiderblog.6c9ee6ec.png";